export const meta = { id: 'O09', slug: 'configurar-niveis', title: 'Como configurar Níveis', description: 'Estruture graus de desenvolvimento claros para cada Competência.', profile: 'owner', category: 'metodologia', type: 'task', status: 'published', order: 390, keywords: ['níveis','competência','desenvolvimento','descritores'], previous: 'O08', next: 'O10', related: ['O08','O10'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como configurar Níveis

Os níveis representam diferentes graus de desenvolvimento de uma Competência.

<HelpImage pendingId="O09.1" alt="Configuração de níveis e descritores" />

## Boas práticas

- diferencie os níveis por comportamento, não apenas por número;
- mantenha progressão coerente entre um nível e outro;
- use linguagem compreensível para quem será avaliado;
- evite níveis que descrevam praticamente a mesma coisa.

<Callout type="concept">O número organiza a escala. O descritor é o que dá significado ao nível.</Callout>
